<template>
  <div class="CloudShow">
    <header>
      <div class="Title">
        <img src="../../assets/Home/组 23265@2x.png" alt />
      </div>
      <div class="dataCensus">
        <p class="dataCensusp">数据概览</p>
        <ul>
          <li v-for="(i, n) in DataCensus" :key="n">
            <span>{{ i.num }}</span>
            <br />
            <img src="../../assets/Home/编组 39@2x.png" alt />
            <p>{{ i.title }}</p>
          </li>
        </ul>
      </div>
    </header>
    <!-- 成果厅 -->
    <div class="ResultT">
      <div class="left_arrow" @click="nextFruit">
        <img src="../../assets/Home/矩形 5 拷贝 2@2x(1).png" alt />
      </div>
      <div class="right_arrow" @click="backFruit">
        <img src="../../assets/Home/矩形 5 拷贝 2@2x.png" alt />
      </div>
      <p class="Result-p">成果厅</p>
      <div class="container">
        <div class="resultSource">
          <div class="option">成果来源：</div>
          <ul>
            <li
              v-for="(item, n) in resultSource"
              :key="item.id"
              :class="areaIndex === n ? 'focusClass' : ''"
              @click="choseChaFrom(item, n)"
            >{{ item.Title }}</li>
          </ul>
        </div>

        <div class="technicalField">
          <div class="option">技术领域：</div>
          <div
            class="allbtn"
            @click="choseChaFrom1('', null)"
            :class="areaIndex1 === null ? 'focusClass1' : ''"
          >全部</div>
          <ul v-if="!flag" class="showall">
            <li
              v-for="(item, n) in technicalField"
              :key="item.id"
              :class="areaIndex1 === n ? 'focusClass' : ''"
              @click="choseChaFrom1(item, n)"
            >{{ item.Title }}</li>
          </ul>
          <ul v-if="flag" class="showmore">
            <li
              v-for="(item, n) in technicalField"
              :key="item.id"
              :class="areaIndex1 === n ? 'focusClass' : ''"
              @click="choseChaFrom1(item, n)"
            >{{ item.Title }}</li>
          </ul>
          <!-- 更多、收起 -->
          <p class="more" @click="showTag" v-html="msg"></p>
        </div>
        <!-- 成果厅轮播图 -->
        <div class="scroll">
          <el-carousel indicator-position="outside" arrow="never" ref="fruit">
            <!-- 暂无数据 -->
            <empty v-if="showEmptyR"></empty>
            <!-- 有数据 -->
            <el-carousel-item v-for="(i, n) in ItemDatass" :key="n" ref="cardShow" v-else>
              <ul>
                <li
                  class="resultInfo"
                  v-for="(item, index) in i"
                  :key="index"
                  @click="openDialog(item)"
                >
                  <div class="imgContainer">
                    <img :src="item.PictureUrl" alt />
                  </div>
                  <div class="rightContent">
                    <div id="Titleone">{{ item.Title }}</div>
                    <div id="pText1">
                      <p class="pText">单位名称：{{ item.CompanyOrPersonName }}</p>
                      <p class="pText">合作方式：{{ item.ModeOfCooperation }}</p>
                      <p class="pText">项目阶段：{{ item.ProjectPhaseName }}</p>
                    </div>

                    <!-- <p>项目阶段：{{ item.Propertystatus }}</p> -->
                  </div>
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 需求厅 -->
    <div class="DemandT">
      <div class="left_arrow" @click="nextneed">
        <img src="../../assets/Home/矩形 5 拷贝 2@2x(1).png" alt />
      </div>
      <div class="right_arrow" @click="backneed">
        <img src="../../assets/Home/矩形 5 拷贝 2@2x.png" alt />
      </div>
      <p class="Demand-p">需求厅</p>

      <div class="container">
        <div class="resultSource">
          <div class="option">需求来源：</div>
          <ul>
            <li
              v-for="(item, n) in demandSource"
              :key="item.id"
              :class="areaIndex2 === n ? 'focusClass' : ''"
              @click="choseChaFrom2(item, n)"
            >{{ item.Title }}</li>
          </ul>
        </div>

        <div class="technicalField">
          <div class="option">技术领域：</div>
          <div
            class="allbtn"
            @click="choseChaFrom3('', null)"
            :class="areaIndex3 === null ? 'focusClass1' : ''"
          >全部</div>

          <ul v-if="!flag1" class="showall">
            <li
              v-for="(item, n) in demandField"
              :key="item.id"
              :class="areaIndex3 === n ? 'focusClass' : ''"
              @click="choseChaFrom3(item, n)"
            >{{ item.Title }}</li>
          </ul>
          <ul v-if="flag1" class="showmore">
            <li
              v-for="(item, n) in demandField"
              :key="item.id"
              :class="areaIndex3 === n ? 'focusClass' : ''"
              @click="choseChaFrom3(item, n)"
            >{{ item.Title }}</li>
          </ul>
          <!-- 更多、收起 -->
          <p class="more" @click="showTagD" v-html="msg1"></p>
        </div>
        <!-- 需求轮播图 -->
        <div class="scroll">
          <el-carousel indicator-position="outside" arrow="never" ref="needs">
            <!-- 暂无数据 -->
            <empty v-if="showEmptyD"></empty>

            <el-carousel-item v-for="(i, n) in demandItemDatas" :key="n" v-else>
              <ul>
                <li
                  class="resultInfo"
                  v-for="(item, index) in i"
                  :key="index"
                  @click="openDialog1(item)"
                >
                  <div class="imgContainer">
                    <img :src="item.PictureUrl" alt />
                  </div>
                  <div class="rightContent">
                    <div id="Titleone2">{{ item.Title }}</div>
                    <p class="pText">单位名称：{{ item.CompanyOrPersonName }}</p>
                    <p class="pText">
                      预算资金：
                      <span class="pColor">
                        {{
                        item.InvestMoney == "0"
                        ? "面议"
                        : item.InvestMoney + "万元"
                        }}
                      </span>
                    </p>
                    <!-- <p class="pText">预算资金：<span class="pColor" >面议</span></p> -->
                    <!-- <p>项目阶段：{{ 没字段 }}</p> -->
                    <p class="pText">技术领域：{{ item.TechFieldEnum }}</p>
                  </div>
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 云路演 -->
    <div class="PlayerT">
      <div class="left_arrow" @click="nextroad">
        <img src="../../assets/Home/矩形 5 拷贝 2@2x(1).png" alt />
      </div>
      <div class="right_arrow" @click="backroad">
        <img src="../../assets/Home/矩形 5 拷贝 2@2x.png" alt />
      </div>
      <p class="Player-p">云路演</p>

      <div class="container">
        <div class="resultSource">
          <div class="option">项目来源：</div>
          <ul>
            <li
              v-for="(item, n) in resultSource"
              :key="item.id"
              :class="areaIndex4 === n ? 'focusClass' : ''"
              @click="choseChaFrom4(item, n)"
            >{{ item.Title }}</li>
          </ul>
        </div>

        <div class="technicalField">
          <div class="option">技术领域：</div>
          <div
            class="allbtn"
            @click="choseChaFrom5('', null)"
            :class="areaIndex5 === null ? 'focusClass1' : ''"
          >全部</div>

          <ul v-if="!flag2" class="showall">
            <li
              v-for="(item, n) in technicalField"
              :key="item.id"
              :class="areaIndex5 === n ? 'focusClass' : ''"
              @click="choseChaFrom5(item, n)"
            >{{ item.Title }}</li>
          </ul>
          <ul v-if="flag2" class="showmore">
            <li
              v-for="(item, n) in technicalField"
              :key="item.id"
              :class="areaIndex5 === n ? 'focusClass' : ''"
              @click="choseChaFrom5(item, n)"
            >{{ item.Title }}</li>
          </ul>
          <!-- 更多、收起 -->
          <p class="more" @click="showTagY" v-html="msg2"></p>
        </div>
        <!-- yun轮播图 -->
        <div class="scroll">
          <el-carousel indicator-position="outside" ref="road" arrow="never">
            <!-- 暂无数据 -->
            <empty v-if="showEmptyY"></empty>
            <!-- 有数据 -->
            <el-carousel-item v-for="(i, n) in videoDatas" :key="n" v-else>
              <ul>
                <li class="resultInfo" v-for="(item, index) in i" :key="index">
                  <div class="imgContainer" @click="goDetail(item)">
                    <img :src="item.PictureUrl" alt />
                    <img src="../../assets/Home/视频播放@2x.png" class="floatPlay" alt />
                  </div>
                  <div class="rightContent">
                    <div id="Titleone3">{{ item.Title }}</div>
                    <p class="pText">单位名称：{{ item.CompanyOrPersonName }}</p>
                    <p class="pText">
                      技术领域：{{
                      item.TechFieldEnum.substring(
                      0,
                      item.TechFieldEnum.length - 1
                      )
                      }}
                    </p>
                    <el-button type="primary" @click="Docking(item)">
                      <img src="../../assets/Home/分组 39@2x.png" alt />我要对接
                    </el-button>
                  </div>
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 成果厅详情页 -->
    <result-dialog v-if="isVisible" :isVisible.sync="isVisible" :ID="ID"></result-dialog>
    <!-- 需求厅详情页 -->
    <demand-dialog v-if="isVisible1" :isVisible1.sync="isVisible1" :ID1="ID1"></demand-dialog>
    <!-- 我要对接的弹框 -->
    <Docking
      v-if="iDialogVisible"
      :DialogVisible.sync="iDialogVisible"
      :id="id2.toString()"
      :type="type1"
    ></Docking>
  </div>
</template>

<script>
import { cloudSelect, roldList, imgcommonUrl } from '../../api/url'
import { postAction } from '../../api/api'
import ResultDialog from './resultDialog.vue'
import DemandDialog from './demandDialog.vue'
import Empty from '../../components/empty.vue'
import Docking from '@/components/Docking.vue'
export default {
  components: {
    ResultDialog,
    DemandDialog,
    Empty,
    Docking,
  },
  data() {
    return {
      id2: '',
      DId: '',
      iDialogVisible: false,
      type1: '4',
      DataCensus: [
        {
          title: '参展单位',
          num: 18,
        },
        {
          title: '参展项目',
          num: 18,
        },
        {
          title: '成果厅',
          num: 18,
        },
        {
          title: '需求厅',
          num: 18,
        },
        {
          title: '云路演',
          num: 18,
        },
      ],
      resultSource: [],
      technicalField: [],
      demandSource: [],
      demandField: [],
      // bannerList:[],
      flag: true,
      flag1: true,
      flag2: true,
      // nowFocus: "全部",
      areaIndex: 0,
      areaIndex1: null,
      areaIndex2: 0,
      areaIndex3: null,
      areaIndex4: 0,
      areaIndex5: null,
      msg: '更多<span class="el-icon-arrow-down"></span>',
      msg1: '更多<span class="el-icon-arrow-down"></span>',
      msg2: '更多<span class="el-icon-arrow-down"></span>',
      itemData: [],
      ItemDatass: [],
      demandDatas: [],
      demandItemDatas: [],
      // playerDatas: [],
      videoData: [],
      videoDatas: [],
      // playerItemDatas: [],
      TechnologySource: '',
      TechFieldEnum: '',
      TechnologySource1: '',
      TechFieldEnum1: '',
      TechnologySource2: '',
      TechFieldEnum2: '',
      ID: '',
      ID1: '',
      isVisible: false,
      isVisible1: false,
      // Visible1: false,
      showEmptyR: false,
      showEmptyD: false,
      showEmptyY: false,
    }
  },
  created() {
    this.loadCount()
    this.loadSelection()
    this.demandSelection()
    if (sessionStorage.getItem('CloudShowresult') != null) {
      this.getsessionResult()
    } else {
      this.loadResult()
    }

    this.loadDemand()
    this.loadPlayer()
    //// console.log(this.isVisible, "this.isVisible");
    //// console.log(this.isVisible1, "this.isVisible1");
  },

  methods: {
    // 路演下一页
    backroad() {
      this.$refs.road.next()
    },
    // 路演上一页
    nextroad() {
      this.$refs.road.prev()
    },
    // 需求下一页
    backneed() {
      this.$refs.needs.next()
    },
    // 需求上一页
    nextneed() {
      this.$refs.needs.prev()
    },
    // 成果下一页
    backFruit() {
      this.$refs.fruit.next()
    },
    // 成果上一页
    nextFruit() {
      this.$refs.fruit.prev()
    },
    // 统计条数
    loadCount() {
      let data = {
        action: 'Get_Count',
      }
      postAction(cloudSelect, this.$qs.stringify(data)).then((res) => {
        // debugger
        //// console.log("统计条数", res);
        let vm = this
        // vm.DataCensus[0].num = res[0].rows;
        // vm.DataCensus[1].num = res[0].r;
        // vm.DataCensus[2].num = res[0].r1;
        // vm.DataCensus[3].num = res[0].r2;
        // vm.DataCensus[4].num = res[0].r4;
        vm.DataCensus[0].num = res[0].参展单位
        vm.DataCensus[1].num = res[0].参展项目
        vm.DataCensus[2].num = res[0].成果厅
        vm.DataCensus[3].num = res[0].需求厅
        vm.DataCensus[4].num = res[0].云路演
        // vm.DataCensus[5].num = res[0].r3
      })
    },
    // 成果厅选项
    loadSelection() {
      let data = {
        action: 'Get_Screen',
      }
      postAction(cloudSelect, this.$qs.stringify(data)).then((res) => {
        //// console.log("标签", res);
        res.TechnicalOrigin.unshift({
          Title: '全部',
          id: '',
        })
        // res.TechFieldEnum.unshift({
        //   Title: "全部",
        //   id: "",
        // });
        this.resultSource = res.TechnicalOrigin

        this.technicalField = res.TechFieldEnum
      })
    },
    // 需求厅选项
    demandSelection() {
      let data = {
        action: 'Get_MajorDemandScreen',
      }
      postAction(cloudSelect, this.$qs.stringify(data)).then((res) => {
        // //// console.log(res);
        // debugger
        res.TechnicalOrigin.unshift({
          Title: '全部',
          id: '',
        })
        // res.TechFieldEnum.unshift({
        //   Title: "全部",
        //   id: "",
        // });
        this.demandSource = res.TechnicalOrigin
        this.demandField = res.TechFieldEnum
      })
    },
    //
    getsessionResult() {
      let mc = sessionStorage.getItem('CloudShowresult')
      var sessionResult = JSON.parse(mc)
      // // console.log(sessionResult)
      let vm = this
      //数据分组
      if (sessionResult.length == 0) {
        this.showEmptyR = true
      } else {
        this.showEmptyR = false

        let vm = this
        //数据分组
        var m = 0
        vm.itemDatas = []
        // //// console.log(vm.itemDatas)
        vm.itemDatas[m] = []
        for (var i = 0; i < sessionResult.length; i++) {
          vm.itemDatas[m].push(sessionResult[i])
          if (vm.itemDatas[m].length == 6 && i < sessionResult.length - 1) {
            m++
            vm.itemDatas[m] = []
          }
        }
        // //// console.log(vm.itemDatas)
        if (vm.itemDatas.length > 0) {
          vm.showItem = 0
          vm.ItemDatass = vm.itemDatas
        }
      }
    },

    //加载成果厅轮播页面
    loadResult() {
      let data = {
        action: 'Achievements_BindList',
        TechFieldEnum: this.TechFieldEnum,
        TechnologySource: this.TechnologySource,
      }
      postAction(cloudSelect, this.$qs.stringify(data)).then((res) => {
        //// console.log("loadResult获取技术成果+长度", res, res.length);

        if (res.length == 0) {
          this.showEmptyR = true
        } else {
          this.showEmptyR = false

          // this.bannerList=res;
          let vm = this
          //数据分组
          var m = 0
          vm.itemDatas = []
          // //// console.log(vm.itemDatas)
          vm.itemDatas[m] = []
          for (var i = 0; i < res.length; i++) {
            vm.itemDatas[m].push(res[i])
            if (vm.itemDatas[m].length == 6 && i < res.length - 1) {
              m++
              vm.itemDatas[m] = []
            }
          }
          // //// console.log(vm.itemDatas)
          if (vm.itemDatas.length > 0) {
            vm.showItem = 0
            vm.ItemDatass = vm.itemDatas
          }
        }
      })
    },
    //加载需求厅轮播页面
    loadDemand() {
      let data = {
        action: 'Demand_BindList',
        TechFieldEnum: this.TechFieldEnum1,
        TechnologySource: this.TechnologySource1,
      }
      postAction(cloudSelect, this.$qs.stringify(data)).then((res) => {
        // debugger
        //// console.log("loadDemand获取需求厅", res);
        if (res.length == 0) {
          this.showEmptyD = true
        } else {
          this.showEmptyD = false
          // this.demandList=res;
          let vm = this
          //数据分组
          var m = 0
          vm.demandDatas = []
          // //// console.log(vm.demandDatas);
          vm.demandDatas[m] = []
          for (var i = 0; i < res.length; i++) {
            vm.demandDatas[m].push(res[i])
            if (vm.demandDatas[m].length == 6 && i < res.length - 1) {
              m++
              vm.demandDatas[m] = []
            }
          }
          // //// console.log(vm.demandDatas);
          if (vm.demandDatas.length > 0) {
            // vm.showItem = 0
            vm.demandItemDatas = vm.demandDatas
          }
        }
      })
    },
    //加载云路演轮播页面
    loadPlayer() {
      let data = {
        action: 'Get_RoadShowWebList',
        state: '1',
        pageSize: 9999,
        page: 1,
        sort: 'UpdateTime DESC',
        TechFieldEnum: this.TechFieldEnum2,
        TechnologySource: this.TechnologySource2,
      }
      postAction(roldList, this.$qs.stringify(data)).then((res) => {
        //// console.log("云路演轮播页1111", res);
        if (res.count == 0) {
          this.showEmptyY = true
          //// console.log("this.showEmptyY", this.showEmptyY);
        } else {
          this.showEmptyY = false
          let vm = this
          //数据分组
          var m = 0
          vm.videoData = []
          vm.videoData[m] = []

          //// console.log(vm.videoData);

          for (var i = 0; i < res.data.length; i++) {
            let data = ''
            if (res.data[i].TechFieldEnum.indexOf('5') !== -1) {
              data += '新一代信息技术,'
            }
            if (res.data[i].TechFieldEnum.indexOf('7') !== -1) {
              data += '高端装备制造,'
            }
            if (res.data[i].TechFieldEnum.indexOf('10') !== -1) {
              data += '新型材料,'
            }
            if (res.data[i].TechFieldEnum.indexOf('11') !== -1) {
              data += '新能源及新能源汽车,'
            }
            if (res.data[i].TechFieldEnum.indexOf('13') !== -1) {
              data += '现代农业,'
            }
            if (res.data[i].TechFieldEnum.indexOf('14') !== -1) {
              data += '食品工业,'
            }
            if (res.data[i].TechFieldEnum.indexOf('9') !== -1) {
              data += '生物医药及健康,'
            }
            if (res.data[i].TechFieldEnum.indexOf('8') !== -1) {
              data += '节能环保,'
            }
            if (res.data[i].TechFieldEnum.indexOf('15') !== -1) {
              data += '公共安全和应急处置,'
            }
            if (res.data[i].TechFieldEnum.indexOf('16') !== -1) {
              data += '其他,'
            }
            // //// console.log('res.data[i]',res.data[i])
            // res.data[i].PictureUrl = imgcommonUrl + res.data[i].PictureUrl;
            // res.data[i].PictureUrl =  res.data[i].PictureUrl;
            res.data[i].TechFieldEnum = data
            vm.videoData[m].push(res.data[i])
            if (vm.videoData[m].length == 3 && i < res.data.length - 1) {
              m++
              vm.videoData[m] = []
            }

            // //// console.log("vm.videoData",vm.videoData)
          }

          if (vm.videoData.length > 0) {
            // vm.showItem = 0
            vm.videoDatas = vm.videoData
          }
        }
      })
    },
    //  更多、收起
    showTag() {
      if (this.flag) {
        this.msg = '收起<span class="el-icon-arrow-up"></span>'
        this.flag = !this.flag
        document.getElementsByClassName('ResultT')[0].style.height = '57.1875rem'
      } else {
        this.msg = '更多<span class="el-icon-arrow-down"></span>'
        this.flag = !this.flag
        document.getElementsByClassName('ResultT')[0].style.height = '53.1875rem'
      }
    },
    showTagD() {
      if (this.flag1) {
        this.msg1 = '收起<span class="el-icon-arrow-up"></span>'
        this.flag1 = !this.flag1
        document.getElementsByClassName('DemandT')[0].style.height = '58.1875rem'
      } else {
        this.msg1 = '更多<span class="el-icon-arrow-down"></span>'
        this.flag1 = !this.flag1
        document.getElementsByClassName('DemandT')[0].style.height = '54.1875rem'
      }
    },
    showTagY() {
      if (this.flag2) {
        this.msg2 = '收起<span class="el-icon-arrow-up"></span>'
        this.flag2 = !this.flag2
        document.getElementsByClassName('PlayerT')[0].style.height = '44.125rem'
      } else {
        this.msg2 = '更多<span class="el-icon-arrow-down"></span>'
        this.flag2 = !this.flag2
        document.getElementsByClassName('PlayerT')[0].style.height = '40.125rem'
      }
    },
    // FocusNow(Title) {
    //   this.nowFocus = Title;
    // },
    choseChaFrom(i, n) {
      // debugger
      //// console.log(i.id);
      this.areaIndex = n
      this.TechnologySource = i.id
      this.loadResult()
    },
    choseChaFrom1(i, n) {
      this.areaIndex1 = n
      this.TechFieldEnum = i.id === '' ? '' : i.id
      // layer.load();
      this.loadResult()
    },
    choseChaFrom2(i, n) {
      // debugger
      //// console.log(i.id);
      this.areaIndex2 = n
      this.TechnologySource1 = i.id
      this.loadDemand()
    },
    choseChaFrom3(i, n) {
      this.areaIndex3 = n
      this.TechFieldEnum1 = i.id === '' ? '' : i.id
      // layer.load();
      this.loadDemand()
    },
    choseChaFrom4(i, n) {
      // debugger
      // //// console.log(i.id);
      this.areaIndex4 = n
      this.TechnologySource2 = i.id
      this.loadPlayer()
    },
    choseChaFrom5(i, n) {
      this.areaIndex5 = n
      this.TechFieldEnum2 = i.id === '' ? '' : i.id
      // layer.load();
      this.loadPlayer()
    },
    // 去成果厅详情页
    openDialog(i) {
      this.isVisible = true
      this.ID = i.ID
    },
    // 去需求厅详情页
    openDialog1(i) {
      this.isVisible1 = true
      //// console.log("需求厅openDialog1", i.ID);
      this.ID1 = i.ID
    },
    goDetail(i) {
      //// console.log("i", i);
      const new1 = this.$router.resolve({
        path: '/yunDetail',
        query: { dID: i.DId, type: i.type, aID: i.AId },
      })
      window.open(new1.href, '_blank')
      //   this.$router.push({
      //     path: "/yunDetail",
      //     query: { dID: i.DId, type: i.type, aID: i.AId },
      //   });
    },
    // 我要对接（先判断是否登录）
    Docking(i) {
      //// console.log("iiiii", i);
      let RealName = localStorage.getItem('RealName')
      let vm = this
      //// console.log("index页面的我要对接");
      // 判断是否登录
      if (RealName == '') {
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        // 打开弹框
        this.iDialogVisible = true
        if (i.type == '1') {
          vm.id2 = i.DId
          //// console.log("1112222", vm.id2);
        } else {
          vm.id2 = i.AId
          //// console.log("2222222", vm.id2);
        }
        //// console.log("index页面点击了yunDetail我要对接pid", vm.id2);
        // //// console.log('this.DialogVisible',this.DialogVisible)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.CloudShow {
  height: 205.625rem;
  font-size: 1rem;
  background: linear-gradient(94deg, #035fd0 0%, #257aeb 100%);
}
header {
  width: 100%;
  height: 52.5rem;
  background: url('../../assets/Home/1@2x.png');
  background-size: 100% 100%;
  .Title {
    padding-top: 3.75rem;
    img {
      width: 35rem;
      height: auto;
    }
  }
  .dataCensus {
    width: 79.875rem;
    height: 20.125rem;
    margin: 3.75rem auto 0;
    background: url('../../assets/Home/组 23270@2x.png');
    background-size: 100% 100%;
    .dataCensusp {
      /* width: 8rem; */
      height: 2.8125rem;
      font-size: 2.125rem;
      font-weight: bold;
      /* line-height: 2.8125rem; */
      color: #ffffff;
      margin: 0 auto;
      padding-top: 0.55rem;
      /* margin-bottom: 1.25rem; */
      opacity: 1;
    }
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 10.125rem;
      width: 66.3125rem;
      margin: 4rem auto 0;
      li {
        position: relative;
        color: #fff;
        font-size: 18px;
        font-family: Microsoft YaHei;
        span {
          position: absolute;
          left: 0;
          right: 0;
          margin: auto;
          font-size: 42px;
          font-family: DIN;
          font-weight: bold;
        }
        img {
          width: 6.8125rem;
        }
      }
    }
  }
}
/* 成果厅 */
.ResultT {
  background: url('../../assets/Home/组 23272@2x.png');
  background-size: 100% 100%;
  width: 80rem;
  height: 53.1875rem;
  margin: -8.5rem auto 0;
  font-family: Microsoft YaHei;
  position: relative;
  overflow: hidden;
  .left_arrow {
    width: 20px;
    height: 38px;
    position: absolute;
    top: 50%;
    left: 20px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  .right_arrow {
    width: 20px;
    height: 38px;
    position: absolute;
    top: 50%;
    right: 20px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  .Result-p {
    width: 8rem;
    height: 2.8125rem;
    font-size: 2.125rem;
    font-weight: bold;
    line-height: 2.8125rem;
    color: #ffffff;
    margin: 0 auto;
    padding-top: 0.4625rem;
    margin-bottom: 1.25rem;
    opacity: 1;
  }
  .container {
    position: absolute;
    left: 5.75rem;
    width: 71rem;
    /* height: 44.875rem; */
    opacity: 1;
    margin: 0 auto;
    li {
      height: 1.3125rem;
      color: #666666;
      padding: 0.475rem;
      cursor: pointer;
      margin-right: 1.55rem;
    }
    .focusClass {
      border-radius: 0.3125rem;
      color: #ffffff;
      background: #2769dc;
      box-shadow: 0 0 0.375rem #004fa4;
    }
    .option {
      height: 1.875rem;
      /* line-height: 1.875rem; */
      width: 7.538rem;
      font-weight: bold;
      padding: 0.475rem;
    }
    .resultSource {
      display: flex;
      /* height: 2.875rem; */
      // margin-top: 1.25rem;

      ul {
        display: flex;
      }
    }
    /deep/.el-carousel__container {
      min-height: 38.5rem;
    }
    .technicalField {
      display: flex;
      margin-bottom: 0.7rem;
      margin-top: -0.25rem;
      overflow: hidden;
      .allbtn {
        /* width: 2.1375rem; */
        height: 1.3125rem;
        padding: 0.475rem;
        cursor: pointer;
        color: #666666;
        margin-right: 1.31rem;
      }
      .focusClass1 {
        /* margin-left: .5rem; */
        border-radius: 0.3125rem;
        color: #ffffff;
        background: #2769dc;
        padding: 0.475rem;
        box-shadow: 0 0 0.375rem #004fa4;
      }
      .showall {
        width: 40.5rem;
        display: flex;
        overflow: hidden;
        flex-wrap: wrap;
      }
      .showmore {
        width: 40.5rem;
        height: 2.9rem;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
      }
      .more {
        cursor: pointer;
        width: 4.625rem;
        float: right;
        padding-top: 0.4375rem;
        margin-left: 11rem;
      }
    }
    .scroll {
      height: 34.5rem;
      .el-carousel__container {
        height: 34.5rem !important;
      }
      /deep/.el-carousel__indicators--horizontal {
        .el-carousel__indicator--horizontal button {
          width: 0.75rem;
          height: 0.75rem;
          background: #2769dc;
          border-radius: 50%;
          opacity: 0.4;
        }
        .el-carousel__indicator--horizontal.is-active button {
          width: 2.25rem;
          height: 0.75rem;
          background: #2769dc;
          opacity: 1;
          border-radius: 10px;
        }
      }

      ul {
        display: flex;
        flex-wrap: wrap;
        justify-self: start;
        /* justify-content: space-around; */
        li {
          margin-bottom: 1.875rem;
          margin-right: 1.875rem;
          width: 32.5625rem;
          height: 10.25rem;
          background: #ffffff;
          display: flex;
          .imgContainer {
            width: 9.625rem;
            height: 6.875rem;
            padding: 1.1875rem 0.75rem 0.75rem 0.625rem;
            img {
              width: 100%;
            }
          }
          .rightContent {
            width: 17.5rem;
            height: 6.75rem;
            text-align: left;
            font-size: 0.875rem;
            padding: 1.1rem 0 1.525rem 1.25rem;

            #Titleone {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              /* font-size: 1.5rem; */
              font-size: 1.125rem;
              font-weight: bold;
              margin-bottom: 0.8125rem;

              color: #4a4a4a;
              /* padding: 1.1rem 0 1.525rem 1.25rem; */
            }
            #pText1 {
              line-height: 1.625rem;
              .pText {
                color: #999999;
                line-height: 1.625rem;
              }
              p {
                margin-bottom: 0.25rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
}
//需求厅
.DemandT {
  background: url('../../assets/Home/组 23272@2x.png');
  background-size: 100% 100%;
  width: 80rem;
  height: 54.1875rem;
  margin: 3.6875rem auto 0;
  font-family: Microsoft YaHei;
  position: relative;
  overflow: hidden;
  .left_arrow {
    width: 20px;
    height: 38px;
    position: absolute;
    top: 50%;
    left: 20px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  .right_arrow {
    width: 20px;
    height: 38px;
    position: absolute;
    top: 50%;
    right: 20px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  .Demand-p {
    width: 8rem;
    height: 2.8125rem;
    font-size: 2.125rem;
    font-weight: bold;
    line-height: 2.8125rem;
    color: #ffffff;
    margin: 0 auto;
    padding-top: 0.4625rem;
    margin-bottom: 1.25rem;
    opacity: 1;
  }
  .container {
    position: absolute;
    left: 5.75rem;
    width: 71rem;
    opacity: 1;
    margin: 0 auto;
    li {
      height: 1.3125rem;
      color: #666666;
      padding: 0.475rem;
      cursor: pointer;
      margin-right: 1.55rem;
    }
    .focusClass {
      border-radius: 0.3125rem;
      color: #ffffff;
      background: #2769dc;
      box-shadow: 0 0 0.375rem #004fa4;
    }
    .option {
      height: 1.875rem;
      /* line-height: 1.875rem; */
      width: 7.538rem;
      font-weight: bold;
      padding: 0.475rem;
    }
    .resultSource {
      display: flex;
      /* height: 2.875rem; */
      margin-top: 1.25rem;

      ul {
        display: flex;
      }
    }
    /deep/.el-carousel__container {
      min-height: 38.5rem;
    }
    .technicalField {
      display: flex;
      margin-bottom: 0.7rem;
      margin-top: -0.25rem;
      overflow: hidden;
      .allbtn {
        /* width: 2.1375rem; */
        height: 1.3125rem;
        padding: 0.475rem;
        cursor: pointer;
        color: #666666;
        margin-right: 1.31rem;
      }
      .focusClass1 {
        /* margin-left: .5rem; */
        border-radius: 0.3125rem;
        color: #ffffff;
        background: #2769dc;
        padding: 0.475rem;
        box-shadow: 0 0 0.375rem #004fa4;
      }
      .showall {
        width: 40.5rem;
        display: flex;
        overflow: hidden;
        flex-wrap: wrap;
      }
      .showmore {
        width: 40.5rem;
        height: 2.9rem;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
      }
      .more {
        cursor: pointer;
        width: 4.625rem;
        float: right;
        padding-top: 0.4375rem;
        margin-left: 11rem;
      }
    }
    .scroll {
      height: 34.5rem;
      .el-carousel__container {
        height: 34.5rem !important;
      }
      /deep/.el-carousel__indicators--horizontal {
        .el-carousel__indicator--horizontal button {
          width: 0.75rem;
          height: 0.75rem;
          background: #2769dc;
          border-radius: 50%;
          opacity: 0.4;
        }

        .el-carousel__indicator--horizontal.is-active button {
          width: 2.25rem;
          height: 0.75rem;
          background: #2769dc;
          opacity: 1;
          border-radius: 10px;
        }
      }

      ul {
        display: flex;
        flex-wrap: wrap;
        /* justify-content: space-around; */
        li {
          margin-bottom: 1.875rem;
          margin-right: 1.875rem;
          /* width: 27.5625rem;
          height: 10.25rem; */
          width: 32.5625rem;
          height: 10.25rem;
          background: #ffffff;
          display: flex;
          .imgContainer {
            width: 9.625rem;
            height: 6.875rem;
            padding: 1.1875rem 0.75rem 0.75rem 0.625rem;
            img {
              width: 100%;
            }
          }
          .rightContent {
            width: 17.5rem;
            height: 6.75rem;
            text-align: left;
            font-size: 0.875rem;
            padding: 1.1rem 0 1.525rem 1.25rem;
            #Titleone2 {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              /* font-size: 1.5rem; */
              font-size: 1.125rem;
              font-weight: bold;
              margin-bottom: 0.8125rem;
              color: #4a4a4a;
              /* padding: 1.1rem 0 1.525rem 1.25rem; */
            }
            .pColor {
              color: rgb(229, 50, 45);
            }
            .pText {
              color: #999999;
              line-height: 1.625rem;
            }
            p {
              font-size: 0.875rem;
              line-height: 1.625rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 0.25rem;
            }
          }
        }
      }
      ul:after {
        content: '';
        width: 30%;
        border: 1px solid transparent;
      }
    }
  }
}
/* 云路演 */
.PlayerT {
  background: url('../../assets/Home/组 23272@2x.png');
  background-size: 100% 100%;
  width: 80rem;
  height: 40.125rem;
  margin: 3.6875rem auto 0;
  font-family: Microsoft YaHei;
  position: relative;
  overflow: hidden;
  .left_arrow {
    width: 20px;
    height: 38px;
    position: absolute;
    top: 50%;
    left: 20px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  .right_arrow {
    width: 20px;
    height: 38px;
    position: absolute;
    top: 50%;
    right: 20px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  .Player-p {
    width: 8rem;
    height: 2.8125rem;
    font-size: 2.125rem;
    font-weight: bold;
    line-height: 2.8125rem;
    color: #ffffff;
    margin: 0 auto;
    /* padding-top: 0.4625rem; */
    margin-bottom: 1.25rem;
    opacity: 1;
  }
  .container {
    position: absolute;
    left: 5.75rem;
    width: 71rem;
    /* height: 44.875rem; */
    opacity: 1;
    margin: 0 auto;
    li {
      height: 1.3125rem;
      color: #666666;
      padding: 0.475rem;
      cursor: pointer;
      margin-right: 1.55rem;
    }
    .focusClass {
      border-radius: 0.3125rem;
      color: #ffffff;
      background: #2769dc;
      box-shadow: 0 0 0.375rem #004fa4;
    }
    .option {
      height: 1.875rem;
      /* line-height: 1.875rem; */
      width: 7.538rem;
      font-weight: bold;
      padding: 0.475rem;
    }
    .resultSource {
      display: flex;
      /* height: 2.875rem; */
      margin-top: 1.25rem;

      ul {
        display: flex;
      }
    }
    /deep/.el-carousel__container {
      min-height: 25.4rem;
      height: 18.75rem;
    }
    .technicalField {
      display: flex;
      margin-bottom: 0.7rem;
      margin-top: -0.25rem;
      overflow: hidden;
      .allbtn {
        /* width: 2.1375rem; */
        height: 1.3125rem;
        padding: 0.475rem;
        cursor: pointer;
        color: #666666;
        margin-right: 1.31rem;
      }
      .focusClass1 {
        /* margin-left: .5rem; */
        border-radius: 0.3125rem;
        color: #ffffff;
        background: #2769dc;
        padding: 0.475rem;
        box-shadow: 0 0 0.375rem #004fa4;
      }
      .showall {
        width: 40.5rem;
        display: flex;
        overflow: hidden;
        flex-wrap: wrap;
      }
      .showmore {
        width: 40.5rem;
        height: 2.9rem;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
      }
      .more {
        cursor: pointer;
        width: 4.625rem;
        float: right;
        padding-top: 0.4375rem;
        margin-left: 11rem;
      }
    }
    .scroll {
      /* height: 34.5rem; */
      .el-carousel__container {
        height: 34.5rem !important;
      }
      /deep/.el-carousel__indicators--horizontal {
        .el-carousel__indicator--horizontal button {
          width: 0.75rem;
          height: 0.75rem;
          background: #2769dc;
          border-radius: 50%;
          opacity: 0.4;
        }

        .el-carousel__indicator--horizontal.is-active button {
          width: 2.25rem;
          height: 0.75rem;
          background: #2769dc;
          opacity: 1;
          border-radius: 10px;
        }
      }

      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 22rem;
          height: 24.975rem;
          background: #ffffff;
          padding: 0;
          /* margin-left: 1.2rem; */
          margin-bottom: 1.333333rem;
          .imgContainer {
            /* width: 20.5rem; */
            /* height: 12.1875rem; */
            /* height: 17.5rem; */
            /* margin-left: -0.48rem; */
            /* margin-top: -1.133333rem; */
            overflow: hidden;
            position: relative;
            // padding: 1.1875rem 0.75rem 0.75rem 0.625rem;
            img {
              /* width: 100%;
              max-height: 12.1875rem; */
              width: 22rem;
              height: 12.1875rem;
            }
            .floatPlay {
              width: 3.125rem;
              height: 3.125rem;
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              margin: auto;
              right: 0;
              img {
                width: 100%;
              }
            }
          }
          .rightContent {
            width: 17.5rem;
            height: 6.75rem;
            text-align: left;
            font-size: 0.875rem;
            padding: 1rem 0 1.25rem 1.25rem;

            #Titleone3 {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              /* font-size: 1.5rem; */
              font-size: 1.125rem;
              font-weight: bold;
              color: #4a4a4a;
              margin-bottom: 0.8125rem;
              /* padding: 1.1rem 0 1.525rem 1.25rem; */
            }
            .pText {
              color: #999999;
              /* line-height: 1.625rem; */
            }
            p {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 0.5rem;
            }
            /deep/.el-button--primary {
              margin-top: 0.8rem;
              /* margin-bottom: 1.25rem; */
              border-color: #2769dc;
              background: #2769dc;
              img {
                vertical-align: middle;
                margin-right: 0.375rem;
                width: 1.125rem;
              }
            }
          }
        }
      }
    }
  }
  .el-button {
    padding: 0.75rem;
    font-size: 0.875rem;
  }
}
</style>
>
